import 'twin.macro';

const ProgressBar = ({ backGroundBar, level }) => {
  return (
    <div tw="bg-white absolute w-[90%] h-[16px]  bottom-6 left-[50%] -translate-x-[50%] p-[4px] rounded-full z-10">
      <div
        tw="rounded-full h-full"
        style={{
          width: `${level}%`,
          background: backGroundBar,
        }}
      />
    </div>
  );
};

export default ProgressBar;
